'use client'
import { cn } from '@/shared/lib/classnames'
import { CardDescription, CardTitle } from '@/shared/ui/card'
import Image, { ImageProps } from 'next/image'
import { HTMLAttributes } from 'react'

export interface CardProps extends HTMLAttributes<HTMLElement> {
  alt: ImageProps['alt']
  src: string
  title: string
  description: string
  textContentClassName?: string
  imageClassName?: string
  titleClassName?: string
}

export default function Card({
  src,
  alt,
  title,
  description,
  className,
  textContentClassName,
  imageClassName,
  titleClassName,
  ...rest
}: CardProps) {
  return (
    <div
      className={cn(
        'flex cursor-pointer flex-col items-center gap-7 rounded-md hover:bg-opacity-75 bg-secondary p-4',
        className,
      )}
      {...rest}
    >
      {!!src && (
        <Image
          src={src}
          blurDataURL={src}
          alt={alt}
          width={192}
          height={120}
          objectFit="cover"
          className={cn('overflow-auto w-full object-contain w-[192px] h-[120px]', imageClassName)}
          placeholder="blur"
          loading="lazy"
        />
      )}

      <div className={cn('flex flex-col gap-3 items-center', textContentClassName)}>
        {title && <CardTitle className={cn(titleClassName)}>{title}</CardTitle>}
        {description && <CardDescription>{description}</CardDescription>}
      </div>
    </div>
  )
}
